import { SEO } from '@/components/SEO';

export function ResponsibleAIPage() {
  return (
    <>
      <SEO
        title="Responsible AI - Nestor"
        description="Our principles and practices for responsible AI development and deployment."
      />

      <div className="container mx-auto px-4 py-20 max-w-4xl">
        <h1 className="text-4xl font-bold mb-8">Responsible AI</h1>
        <div className="prose prose-lg max-w-none space-y-6 text-muted-foreground">
          <p className="text-sm">Last updated: January 24, 2026</p>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">Our AI Principles</h2>
            <p>
              At Nestor, we are committed to developing and deploying AI systems responsibly.
              Our AI features are designed with the following principles:
            </p>
          </section>

          <section>
            <h3 className="text-xl font-semibold text-foreground mt-6 mb-3">1. Fairness</h3>
            <p>
              We actively work to identify and mitigate bias in our AI systems. Our algorithms are
              regularly audited to ensure they don't discriminate based on protected characteristics.
            </p>
          </section>

          <section>
            <h3 className="text-xl font-semibold text-foreground mt-6 mb-3">2. Transparency</h3>
            <p>
              We clearly communicate when AI is being used and how it influences decisions.
              Users have the right to understand AI-driven recommendations and outcomes.
            </p>
          </section>

          <section>
            <h3 className="text-xl font-semibold text-foreground mt-6 mb-3">3. Human Oversight</h3>
            <p>
              AI serves as an assistant, not a replacement for human judgment. Critical decisions
              always require human review and approval.
            </p>
          </section>

          <section>
            <h3 className="text-xl font-semibold text-foreground mt-6 mb-3">4. Privacy & Security</h3>
            <p>
              AI systems are designed with privacy by default. Personal data used for AI training
              is anonymized and protected with the same security measures as all other data.
            </p>
          </section>

          <section>
            <h3 className="text-xl font-semibold text-foreground mt-6 mb-3">5. Accountability</h3>
            <p>
              We maintain clear accountability for AI system behavior. Our AI governance framework
              defines roles, responsibilities, and escalation procedures.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">AI Features in Our Platform</h2>
            <p>We currently use AI for:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>HR chatbot for employee queries</li>
              <li>Resume screening and candidate matching</li>
              <li>Predictive analytics for attrition risk</li>
              <li>Smart recommendations for learning paths</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">Ongoing Commitment</h2>
            <p>
              We continuously monitor and improve our AI systems. We conduct regular bias audits,
              maintain diverse training data, and stay current with evolving best practices in
              responsible AI.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">Questions?</h2>
            <p>
              If you have questions about our AI practices, contact our AI Ethics team at ai-ethics@hrms.com
            </p>
          </section>
        </div>
      </div>
    </>
  );
}
